import React from "react";
import style from "./ClientInfo.module.scss";
import { useTranslation } from "react-i18next";
const DetailItem = ({ label, value }) => {
  const t = useTranslation("");

  return (
    <div className={style.detailItem}>
      <span className={style.label}>{label}:</span>
      <span className={style.value}>{value || t("car.Info.notSpecified")}</span>
    </div>
  );
};

export default DetailItem;
